import { useMemo } from "react";

import { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";

import { hasLandingPagesPermissions } from "./hasLandingPagesPermissions";

export const useLandingPagesPermissions = () => {
  const hasPermission = useDeveloperHasPermission();

  return useMemo(() => {
    const { canReadLandingPages, canCreateLandingPages, canPublishLandingPages } = hasLandingPagesPermissions({
      hasPermission,
    });
    return {
      canReadLandingPages,
      canCreateLandingPages,
      canPublishLandingPages,
    };
  }, [hasPermission]);
};
